import { useState, useCallback } from 'react';
import API from 'api/api';
import { translateApiError } from 'i18n/translateApiError';

export default function useChangeUserAiStatus({ onSettled } = {}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const changeUserAiStatus = useCallback(
    async (userId, aiEnabled) => {
      if (!userId) {
        setError('User ID is required');
        return false;
      }

      setLoading(true);
      setError(null);

      try {
        await API.put(`/users/${userId}/ai-status`, { aiEnabled });

        if (onSettled) {
          onSettled();
        }

        return true;
      } catch (err) {
        setError(translateApiError(err, 'Failed to change AI status'));

        if (onSettled) {
          onSettled();
        }

        return false;
      } finally {
        setLoading(false);
      }
    },
    [onSettled],
  );

  return {
    changeUserAiStatus,
    loading,
    error,
  };
}
